// Les pages pre-rendues (voir scripts/prerender.js) portent <html data-prerendered>.
// Au premier chargement, les animations d'entree sont sautees : le HTML statique et le
// premier rendu React sont alors identiques (texte visible, pas de clignotement).
export const skipIntro = () => typeof document !== "undefined" && document.documentElement.hasAttribute("data-prerendered");
